export default __webpack_public_path__ + "static/media/coodash-marker.d9dc23a2.svg";